import React from "react";
import * as Types from "../types/BaseTypes";
import Slider from "./Slider";
import Room from "../images/room";
import ACUnit from "../images/acUnit";

export default (props: {
  core: Types.Core;
  room: Types.Room;
  setRoom: Function;
  height: Types.HeightFactor;
  setHeight: Function;
  next: Function;
  prev: Function;
  testRoom: { get: Types.RoomBaseTest; set: Function };
  estimate: number;
  estimateTest: string;
  updateEstimate: Function;
  factor: Types.HeightFactor;
}) => {
  const {
    core,
    room,
    setRoom,
    height,
    setHeight,
    next,
    prev,
    testRoom,
    estimate,
    estimateTest,
    updateEstimate,
    factor,
  } = props;

  const getSliderLeft = () => {
    switch (height) {
      case Types.HeightFactor.FloorLocation: {
        return 0;
      }
      case Types.HeightFactor.WindowMounted: {
        return 1;
      }
      case Types.HeightFactor.WallMounted: {
        return 2;
      }
      case Types.HeightFactor.CeilingMounted: {
        return 3;
      }
      default:
        return 0;
    }
  };

  return (
    <div className={"page p-dimensions"} style={{ maxWidth: 1000 }}>
      {core.application === Types.Application.HumanComfort && (
        <Slider
          height={{ get: height, set: (e: Types.HeightFactor) => setHeight(e) }}
          type={height}
          typePrimitive={"height"}
          data={[
            {
              value: Types.HeightFactor.FloorLocation,
              title: `Floor Location ${Types.HeightFactor.FloorLocation}m`,
              mobile: `Floor`,
            },
            {
              value: Types.HeightFactor.WindowMounted,
              title: `Window Mounted ${Types.HeightFactor.WindowMounted}m`,
              mobile: `Window`,
            },
            {
              value: Types.HeightFactor.WallMounted,
              title: `Wall Mounted ${Types.HeightFactor.WallMounted}m`,
              mobile: `Wall`,
            },
            {
              value: Types.HeightFactor.CeilingMounted,
              title: `Ceiling Mounted ${Types.HeightFactor.CeilingMounted}m`,
              mobile: `Ceiling`,
            },
          ]}
          getSliderLeft={() => getSliderLeft()}
          mobileWidth={750}
        />
      )}
      <div
        className={"details-panel"}
        style={{
          maxWidth: 930,
          padding: 0,
          marginTop:
            core.application !== Types.Application.HumanComfort ? 40 : 0,
          width: "calc(100% - 40px)",
          display: "flex",
          flexFlow: "row",
          overflow: "hidden",
        }}
      >
        <div
          style={{ padding: 30, width: "50%", textAlign: "center" }}
          className="room"
        >
          {testRoom.get.height !== "" && (
            <label className="inputLabel">Height (m)</label>
          )}
          <input
            placeholder="Height"
            className={
              room.height !== +testRoom.get.height.replace(",", ".")
                ? "error"
                : ""
            }
            type="text"
            value={testRoom.get.height}
            onChange={(e) =>
              testRoom.set({ ...testRoom.get, height: e.target.value })
            }
            maxLength={5}
            style={{ margin: "auto", display: "block" }}
          />

{core.application === Types.Application.HumanComfort && <ACUnit factor={factor} />}
 
 
          <Room />

          <div className="room-input-bot">
            <div style={{ position: "relative" }}>
              {testRoom.get.width !== "" && (
                <label className="inputLabel">Width (m)</label>
              )}
              <input
                placeholder="Width"
                className={
                  room.width !== +testRoom.get.width.replace(",", ".")
                    ? "error"
                    : ""
                }
                type="text"
                value={testRoom.get.width}
                onChange={(e) =>
                  testRoom.set({ ...testRoom.get, width: e.target.value })
                }
                maxLength={5}
              />
            </div>
            <div style={{ position: "relative" }}>
              {testRoom.get.length !== "" && (
                <label className="inputLabel">Length (m)</label>
              )}
              <input
                placeholder="Length"
                className={
                  room.length !== +testRoom.get.length.replace(",", ".")
                    ? "error"
                    : ""
                }
                type="text"
                value={testRoom.get.length}
                onChange={(e) =>
                  testRoom.set({ ...testRoom.get, length: e.target.value })
                }
                maxLength={5}
              />
            </div>
          </div>
        </div>

        <div
          style={{
            padding: 30,
            width: "50%",
            display: "flex",
            flexFlow: "column",
            justifyContent: "space-between",
          }}
        >
          <div style={{ textAlign: "right" }}>
            <span
              style={{
                display: "inline",
                fontSize: 14,
                fontWeight: "bold",
                color: "#525C61",
              }}
            >
              Estimated Refrigerant Charge / kg:
            </span>
            <input
              style={{ marginLeft: 15 }}
              placeholder="0"
              className={
                estimate !== +estimateTest.replace(",", ".") ? "error" : ""
              }
              type="text"
              value={estimateTest}
              onChange={(e) => updateEstimate(e.target.value)}
              maxLength={5}
            />
          </div>
          <div style={{ textAlign: "right" }}>
            <span className="details-colored">
              Room Area: <span>{room.square.toFixed(2)} m²</span>
            </span>
            <span className="details-colored">
              Room Volume: <span>{room.cubic.toFixed(2)} m³</span>
            </span>
          </div>
        </div>
      </div>
      <div className="buttons">
        <div onClick={() => prev()}>Back</div>
        <div onClick={() => next()}>Next</div>
      </div>
    </div>
  );
};
